import { T_CONTACT_US_PAGE_CONSTANTS } from './TYPES'

const DE_CONTACT_US_PAGE_CONSTANTS: T_CONTACT_US_PAGE_CONSTANTS = {
  PAGE_KICKER: 'HABEN SIE NOCH FRAGEN?',
  PAGE_TITLE: 'Kontaktieren Sie uns',
  THANKYOU_PAGE_TITLE: 'Ihre Anfrage wurde erfolgreich eingereicht. 🎉',
  GENERIC_ERROR_TOAST_MESSAGE:
    'Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.'
}

export default DE_CONTACT_US_PAGE_CONSTANTS
